(function () {
  require('./jquery.carousel.js')

  var win = $(window)
  var helpers = require('../global/helpers')
  var FormTabsEngine = require('../global/form-tabs-engine')
  var PreparePostInit = require('../global/preparePostInitHookFunction')

  var loadedOffers = []
  var hpOffersElem = $('.hp-special-offers .box')
  var hpOffersBaseUrl = '/opencms/opencms/sys/bloky/homepage/hp-content-middle.block'

  var hpOffers = {
    'dovolena': helpers.cheapestVacation() /*helpers.prepareHtmlLoad('#dovolena .content', hpOffersBaseUrl + '?holiday=1')*/,
    'jazykove-pobyty': helpers.prepareHtmlLoad('#jazykove-pobyty .content', '/opencms/opencms/shared/wc/proxy-jp-pp-sk.jsp?site=jazykovepobyty.sk&count=5'),
    'pracovni-pobyty': helpers.prepareHtmlLoad('#pracovni-pobyty .content', '/opencms/opencms/shared/wc/proxy-jp-pp-sk.jsp?site=pracovnipobyty.sk&count=5'),
    // 'regiojet': helpers.prepareHtmlLoad('#regiojet .content', '//m2jizdenky.sa.cz/cs/novinky/data.html?count=5'),
    'letenky': helpers.prepareWidget('#letenky .content', 'airticketOffersWidget', {count: 10, component_id: 'studentagency.sk', random: 6, set: "default_sk"})
  }
    
  var hpFormsOptions = require('../global/widget-defaults')()

  hpFormsOptions = PreparePostInit(hpFormsOptions, [])

  var hpForms = new FormTabsEngine({
    'form-1': ['airticketForm', hpFormsOptions.letenky],
    'form-2': ['ybusForm', hpFormsOptions.jizdenky],
    'form-3': ['vacationForm', hpFormsOptions.dovolena],
    'form-4': ['studyAbroadForm', hpFormsOptions.jazykovePobyty],
    'form-5': ['workAbroadForm', hpFormsOptions.pracovniPobyty],
    'form-6': ['insuranceForm', hpFormsOptions.pojisteni],
    'form-7': ['accomodationFormBooking','sk', {}],
    'form-8': ['carRentFormBooking', 'sk', {}]
  })

  // Inicializace prvního formuláře
  hpForms.init('form-1')

  $('#form-7').prepend($('<h2/>', {
    'class': hpFormsOptions.ubytovani.header.className,
    text: hpFormsOptions.ubytovani.header.text
  }))

  $('#form-8').prepend($('<h2/>', {
    'class': hpFormsOptions.auta.header.className,
    text: hpFormsOptions.auta.header.text
  }))

  /*
    Pro mazani contentu u tabs
    Nutno vyzkouset
   $( ".tabs" ).tabs({
    beforeLoad: function( event, ui ) {
      console.log('aa')
      $(ui.panel).siblings('.nav-tabs').empty()
    }

    beforeLoad: function(event, ui){
      $(ui.panel).siblings('.ui-tabs-panel').empty()
    }

  })*/

  // homepage banner slider
  $('.infinite-carousel').infiniteCarousel()

  /*
  * Vytvoření accordionu z nabídek pokud jsme na mobilu
  * - pro spocitani spravne vysky okna prohlizece pouzijeme window.innerWidth !!
  * (je to stejna sirka, se kterou pocitaji mediaQueries, kdyz pouzijeme pouze width(),
  * sirka se bude lisit o nekolik desitek pixelu)
  */
  if (window.innerWidth < 768)
    offersAccordion()

  // Skrytí boxů s nabídkami
  // hpOffersElem.fadeTo(0, 0)

  // Vypnout / zapnout accordion při změně rozlišení
  win.resize(toggleOffersAccordion)

  // Načítanie blokov nabídek hneď
  hpOffersElem.each(loadOffersIntoViewport)

  function loadOffersIntoViewport () {
    var elemId = $(this).attr('id')
    if (typeof hpOffers[elemId] === 'function') {
      loadedOffers.push(elemId)
      hpOffers[elemId]()
    }
  }

  // offers accordion
  function toggleOffersAccordion () {

    if (window.innerWidth < 768)
      offersAccordion()

    else if ($('.hp-special-offers').data('uiAccordion'))
      $('.hp-special-offers').accordion('destroy')
  }

  function offersAccordion () {

    $('.hp-special-offers').accordion({
      header: '.box>.box-header',
      heightStyle: 'content'
    })

    $('.hp-special-offers .ui-icon').hide()
  }

})()



// WEBPACK FOOTER //
// ./src/js/homepage/index.js